import React, { useState, useEffect } from "react";
import "./App.css";
import { mockData } from "./components/Constant";
import FormContainer from "./components/FormContainer";
import FormProvider from "./context/FormContext";
import useForm from "./hooks/useForm";
import ErrorScreen from "./screens/ErrorScreen";
import LoadingScreen from "./screens/LoadingScreen";
import { getFormName } from "./utils/constants";
import { useNavigate } from "react-router-dom";

const App = () => {
  const { merchant, data, fetching, error, fetch, formExpired } = useForm();

  useEffect(() => {
    fetch();
  }, []);

  useEffect(() => {
    document.title = getFormName();
  }, [document]);

  if (fetching && !data) {
    return <LoadingScreen />;
  }

  if (!fetching && error) {
    return <ErrorScreen message={"Unable to load form!"} refetch={fetch} />;
  }
  if (
    !fetching &&
    !error &&
    data &&
    (!data.data[0].form_fields || data.data[0].form_fields.length === 0)
  ) {
    return <ErrorScreen message={"Form not found!"} refetch={fetch} />;
  }

  if (!data?.data?.[0]?.is_active) {
    return <ErrorScreen message={"Sorry, this form has been suspended!"} refetch={fetch} />;
  }

  if (formExpired) {
    return <ErrorScreen message={"Sorry, this form has expired!"} refetch={fetch} />;
  }

  return (
    <div className="container">
      {!fetching && !error && data && (
        <FormProvider {...{ ...data.data[0], merchant }}>
          <FormContainer />
        </FormProvider>
      )}
    </div>
  );
};

export default App;
